import { useId, type ReactNode } from 'react';

import { cn } from './cn';
import { Label } from './label';

export interface FieldProps {
  label: ReactNode;
  hint?: ReactNode;
  error?: ReactNode;
  htmlFor?: string;
  className?: string;
  children: (id: string) => ReactNode;
}

export function Field({ label, hint, error, htmlFor, className, children }: FieldProps) {
  const generatedId = useId();
  const id = htmlFor ?? generatedId;
  return (
    <div className={cn('space-y-1.5', className)}>
      <Label htmlFor={id}>{label}</Label>
      {children(id)}
      {hint && !error && <p className="text-xs text-ink-500">{hint}</p>}
      {error && (
        <p role="alert" className="text-xs text-heart">
          {error}
        </p>
      )}
    </div>
  );
}
